export const images = {
    Logos: {
        FullLogoBlack: require("./logos/logo.png"),
        FullLogoOriginal: require("./logos/logo2.png"),
        LogoSlang: require("./logos/logoLM.png"),
        LogoSlangWhite: require("./logos/logoLMwhite.png")

    },

    Badges: {
        Iso27001: require("./badges/ISO-logo.png"),
        Iso27701: require("./badges/ISO-27701-logo.png"),
        Iso22301: require("./badges/Iso22301-logo.png"),
    },

    Backgrounds: {
        AppBackground: require("./backgrounds/AppBackground.jpg")
    },

    Defaults: {
        DataFlowing: require("./defaults/dataFlowing.png"),
        SearchingClient: require("./defaults/searchingClient.png"),
        Analytics: require("./defaults/analytics.png"),
        Cases: require("./defaults/cases.png"),
        CasesType: require("./defaults/casesType.png"),
        TaggedCase: require("./defaults/taggedCase.png"),
        Managers: require("./defaults/managers.png"),
    }
}